const PlusIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2.5V9.5M2.5 6H9.5"
        stroke="#101828"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { PlusIcon };
